import { Segment } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../Buttons/Button";
import Detail from "../Detail/Detail";

export default function MetaSummary({ onEdit, left, right }) {
	const { t } = useTranslation();

	const empty = !left?.some((f) => f.value) && !right?.some((f) => f.value);

	return (
		<Segment padded style={{ paddingRight: 100 }}>
			{onEdit && (
				<div style={{ position: "absolute", top: "1em", right: "1em" }}>
					<Button size="small" onClick={onEdit}>
						{t("edit", "Edit")}
					</Button>
				</div>
			)}

			{empty ? (
				<div style={{ fontStyle: "italic", opacity: 0.5 }}>{t("metaMissing", "Missing information")}</div>
			) : (
				<div style={{ display: "flex", gap: "1em", alignItems: "flex-start" }}>
					<div style={{ display: "flex", gap: "1em", flexWrap: "wrap", flex: "1 1 60%" }}>
						{left
							?.filter(({ value }) => value)
							.map(({ label, value, href, style }) => (
								<Detail
									key={label}
									label={label}
									value={value}
									href={href}
									style={{ flex: "1 1 200px", ...style }}
								/>
							))}
					</div>

					<div style={{ display: "flex", gap: "1em", flexWrap: "wrap", flex: "1 1 40%" }}>
						{right
							?.filter(({ value }) => value)
							.map(({ label, value, href, style }) => (
								<Detail
									key={label}
									label={label}
									value={value}
									href={href}
									style={{ flex: "1 1 200px", ...style }}
								/>
							))}
					</div>
				</div>
			)}
		</Segment>
	);
}
